/**
 * Checks if the device was recently checked successfully (within the last 2 hours).
 * This is used to implement the "Smart Device Memory" feature, skipping
 * redundant device checks during a single candidate sitting.
 */
export const isDeviceRecentlyChecked = () => {
  try {
    const lastCheckedStr = localStorage.getItem('talentcrux_device_checked');
    if (!lastCheckedStr) return false;
    
    const lastChecked = parseInt(lastCheckedStr, 10);
    if (isNaN(lastChecked)) return false;
    
    const TWO_HOURS = 2 * 60 * 60 * 1000;
    return Date.now() - lastChecked < TWO_HOURS;
  } catch (error) {
    // Handle cases where localStorage might be blocked
    return false;
  }
};

/**
 * Marks the device as successfully checked right now.
 */
export const markDeviceAsChecked = () => {
  try {
    localStorage.setItem('talentcrux_device_checked', Date.now().toString());
  } catch (error) {
    // Ignore if localStorage is blocked
  }
};
